export const DEPOSIT_RATE = 0.3

export const BOOKING_SERVICES = [
  { value: 'Box Braids', desc: 'Classic protective braiding style', price: 180 },
  { value: 'Senegalese Twist', desc: 'Smooth, elegant twist look', price: 160 },
  { value: 'Cornrows', desc: 'Neat rows and creative patterns', price: 80 },
  { value: 'Micro Braids', desc: 'Fine, detailed braiding', price: 220 },
  { value: 'Knotless Braids', desc: 'Lightweight, natural finish', price: 200 },
  { value: 'Goddess Braids', desc: 'Braids with curly ends', price: 190 },
  { value: 'Weaving', desc: 'Sew-in and weave services', price: 150 },
  { value: 'Styling', desc: 'Finish, touch-up, and styling', price: 60 },
  { value: 'Other', desc: 'Custom service — price confirmed at consultation', priceFrom: 100 },
]

export const DEPOSIT_METHODS = [
  { id: 'zelle', label: 'Zelle', desc: 'Send deposit via Zelle', depositAccepted: true },
  { id: 'cashapp', label: 'Cash App', desc: 'Send deposit via Cash App', depositAccepted: true },
  { id: 'card', label: 'Card', desc: 'Pay deposit by debit or credit card', depositAccepted: true },
]

export const BALANCE_METHODS = [
  { id: 'cash', label: 'Cash', desc: 'Pay remaining balance in salon' },
  { id: 'zelle', label: 'Zelle', desc: 'Pay balance via Zelle' },
  { id: 'cashapp', label: 'Cash App', desc: 'Pay balance via Cash App' },
  { id: 'card', label: 'Card', desc: 'Pay balance by card in salon' },
]

export const ZELLE_INFO = process.env.REACT_APP_ZELLE || '703-936-3026'
export const CASHAPP_INFO = process.env.REACT_APP_CASHAPP || '$SarahAdomBraiding'

export function getServicePrice(service) {
  if (!service) return 0
  return service.price ?? service.priceFrom ?? 0
}

export function formatMoney(amount) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount)
}

export function calcDeposit(servicePrice) {
  return Math.round(servicePrice * DEPOSIT_RATE * 100) / 100
}
